import { useMutation } from '@tanstack/react-query'
import { authApi } from '../services/auth.service'
import { useApiAuth } from '../state/apiAuthStore'
import { queryClient } from '@/lib/api/queryClient'
import { qk } from '@/lib/api/queryKeys'
import type { ApiError } from '@/lib/api/client'

export function useLoginMutation() {
  const setSession = useApiAuth((s) => s.setSession)
  return useMutation({
    mutationFn: (vars: { identifier: string; password: string }) =>
      authApi.login(vars.identifier, vars.password),
    onSuccess: (result) => {
      setSession(result)
      queryClient.invalidateQueries({ queryKey: qk.auth.me })
      queryClient.invalidateQueries({ queryKey: qk.cart.me })
    },
  })
}

export function useRegisterMutation() {
  const setSession = useApiAuth((s) => s.setSession)
  return useMutation({
    mutationFn: authApi.register,
    onSuccess: (result) => {
      setSession(result)
    },
  })
}

export function useLogoutMutation() {
  const logout = useApiAuth((s) => s.logout)
  return useMutation({
    mutationFn: async () => { logout() },
    onSuccess: () => {
      queryClient.clear()
    },
  })
}

export type { ApiError }
